<template>
  <div class="vuse-content-wrapper contact-app">
    <div v-if="hasAccess('user')">
      <vuse-section-definition :title="page" icon="person" />
      <v-container fluid class="">
        <!-- <v-alert
          v-show="account.data.isAdmin"
          :color="`danger`"
          :class="`m-5 v-alert v-sheet theme--dark elevation-0 v-alert--dense warning`"
        >
          <v-icon>info_outline</v-icon>
          Add Users - $10.00/User/Month</v-alert
        > -->

        <v-row>
          <v-col cols="6" lg="3" md="3" sm="4"
            ><v-text-field
              v-model="filter.SearchTerm"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              solo
              hide-details
            ></v-text-field
          ></v-col>

          <v-col cols="6" lg="3" md="3" sm="4">
            <v-checkbox
              v-show="account.data.isAdmin"
              v-model="filter.isDeleted"
              label="Show Deleted Users Only"
              style="margin-top: 5px"
            />
          </v-col>

          <v-col cols="6" lg="3" md="3" sm="4">
            <v-checkbox
              v-model="filter.isActive"
              label="Show Active Users Only"
              style="margin-top: 5px"
              hide-details
            />
          </v-col>

          <v-col class="text-right">
            <add-form
              :item="selectedItem"
              :show="showEdit"
              @onClosed="clearEdit()"
              @onSucceded="refresh()"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card>
              <v-skeleton-loader
                v-if="isLoading"
                class="mx-auto"
                type="table"
              ></v-skeleton-loader>
              <v-data-table
                v-else
                :headers="activeHeaders"
                :items="dataItems"
                :options.sync="tableOptions"
                :server-items-length="totalItems"
                :loading="loading"
                class="elevation-1"
                :item-class="row_classes"
                :footer-props="{
                  'items-per-page-options': [10, 20, 30, 40, 50, 100, 200],
                }"
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-menu offset-y :close-on-content-click="false">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          rounded
                          class="content-ma-0 mr-2"
                          v-on="on"
                          x-small
                        >
                          <v-icon small>menu</v-icon> Customize Columns
                        </v-btn>
                      </template>
                      <v-list dense>
                        <v-list-item
                          dense
                          :key="i"
                          v-for="(header, i) in headers"
                        >
                          <v-list-item-title v-if="header.readonly">
                            <v-checkbox
                              v-model="headers[i].active"
                              :label="header.text"
                              :disabled="true"
                            />
                          </v-list-item-title>
                          <v-list-item-title v-else>
                            <v-checkbox
                              v-model="headers[i].active"
                              :label="header.text"
                            />
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-toolbar>
                </template>

                <template v-slot:item.lastUpdated="{ item }">
                  <v-chip @click="onEdit(item)" small>
                    {{ item.lastUpdated | formatDatetime }}
                  </v-chip>
                </template>

                <template v-slot:item.firstName="{ item }">
                  <span @click="onEdit(item)"
                    >{{ item.firstName }} {{ item.lastName }}</span
                  >
                </template>

                <template v-slot:item.userName="{ item }">
                  <span @click="onEdit(item)">{{ item.userName }}</span>
                </template>

                <template v-slot:item.email="{ item }">
                  <span @click="onEdit(item)">{{ item.email }}</span>
                </template>

                <template v-slot:item.userGroupName="{ item }">
                  <span @click="onEdit(item)">{{ item.userGroupName }}</span>
                </template>

                <template v-slot:item.isActive="{ item }">
                  <span @click="onEdit(item)">{{
                    item.isActive ? `Yes` : `No`
                  }}</span>
                </template>

                <template v-slot:item.firedDate="{ item }">
                  <span @click="onEdit(item)">{{
                    item.firedDate | formatDate
                  }}</span>
                </template>

                <template v-slot:item.hiredDate="{ item }">
                  <span @click="onEdit(item)">{{
                    item.hiredDate | formatDate
                  }}</span>
                </template>

                <template v-slot:item.supervisorFirstName="{ item }">
                  <span @click="onEdit(item)"
                    >{{ item.supervisorFirstName }}
                    {{ item.supervisorLastName }}</span
                  >
                </template>

                <template v-slot:item.phoneNumber="{ item }">
                  <a
                    :href="`tel:${item.phoneNumber}`"
                    :alt="item.phoneNumber"
                    >{{ item.phoneNumber }}</a
                  >
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn icon small class="content-ma-0" v-on="on">
                        <v-icon small>mdi-cogs</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        @click="onReactive(item)"
                        v-show="account.data.isAdmin && item.isDeleted"
                      >
                        <v-list-item-title>
                          <v-icon small left>person</v-icon>Reactive
                        </v-list-item-title>
                      </v-list-item>

                      <v-list-item
                        @click="onDetail(item)"
                        v-show="hasAccess('user.view')"
                      >
                        <v-list-item-title>
                          <v-icon small left>person</v-icon>Detail
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        @click="onEdit(item)"
                        v-show="hasAccess('user.edit')"
                      >
                        <v-list-item-title>
                          <v-icon small left>mdi-pencil</v-icon>Edit
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        @click="onChangeAdminPassword(item)"
                        v-if="account.data.user.userGroupName === 'Super Admin' && item.userGroupName === 'Super Admin'"
                      >
                        <v-list-item-title>
                          <v-icon small left>lock</v-icon>Change Admin Password
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        @click="onChangePassword(item)"
                        v-if="
                          (hasAccess('user.edit') ||
                          item.id === account.data.user.id) &&
                          item.userGroupName !== 'Super Admin'
                        "
                      >
                        <v-list-item-title>
                          <v-icon small left>lock</v-icon>Change Password
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        @click="onDelete(item)"
                        v-show="
                          account.data.user.id !== item.id &&
                          hasAccess('user.delete') &&
                          !item.isDeleted
                        "
                      >
                        <v-list-item-title>
                          <v-icon small left>delete</v-icon>Delete
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>

        <delete-dialog
          :item="selectedItem"
          :show="showDelete"
          @onSucceded="refresh()"
          @onClosed="clearDelete()"
        />
        <change-password
          :item="selectedItem"
          :show="showChangePassword"
          @onSucceded="refresh()"
          @onClosed="clearChangePassword()"
        />

        <change-admin-password
          :item="selectedItem"
          :show="showChangeAdminPassword"
          @onSucceded="refresh()"
          @onClosed="clearChangeAdminPassword()"
        />

        <detail
          :item="selectedItem"
          :show="showDetail"
          @onSucceded="refresh()"
          @onClosed="clearDetail()"
        />

        <reactive-dialog
          :item="selectedItem"
          :show="showReactive"
          @onSucceded="refresh()"
          @onClosed="clearReactive()"
        />
      </v-container>
    </div>
    <NoPermission v-else />
  </div>
</template>
<script>
import {
  required,
  maxLength,
  minLength,
  email,
} from "vuelidate/lib/validators";
import { validNumber } from "@/utils/validators";
import validationMixin from "@/mixins/validationMixin";
import AddForm from "./User/_users/_Form";
import DeleteDialog from "./User/_users/_Delete";
import ReactiveDialog from "./User/_users/_Reactive";
import ChangePassword from "./User/_users/_ChangePassword";
import ChangeAdminPassword from "./User/_users/_ChangeAdminPassword";
import Detail from "./User/_users/_Detail";
import { mapActions, mapState, mapGetters } from "vuex";
import { getStorage, setStorage } from "src/utils/helpers";
import formatterMixin from "@/mixins/formatterMixin";
import _ from "lodash";
import NoPermission from "components/NoPermission";

const SETTING_LIST_KEY = "users-columns";
const defaultHeaders = [
  {
    text: "Action",
    value: "actions",
    sortable: false,
    readonly: true,
    active: true,
  },
  {
    text: "Full Name",
    align: "start",
    sortable: true,
    value: "firstName",
    active: true,
  },
  {
    text: "User Name",
    align: "start",
    sortable: true,
    value: "userName",
    active: true,
  },
  {
    text: "Email",
    sortable: true,
    value: "email",
    active: true,
  },
  {
    text: "Group",
    sortable: true,
    value: "userGroupName",
    active: true,
  },
  {
    text: "Phone",
    sortable: true,
    value: "phoneNumber",
    active: true,
  },
  {
    text: "Active",
    sortable: true,
    value: "isActive",
    active: true,
  },
  {
    text: "Supervisor",
    sortable: true,
    value: "supervisorFirstName",
    active: true,
  },
  {
    text: "Hired Date",
    sortable: true,
    value: "hiredDate",
    active: true,
  },
  {
    text: "Fired Date",
    sortable: true,
    value: "firedDate",
    active: true,
  },
  {
    text: "Date Modified",
    value: "lastUpdated",
    sortable: true,
    active: false,
  },
];

export default {
  mixins: [validationMixin, formatterMixin],
  components: {
    AddForm,
    DeleteDialog,
    ChangePassword,
    ChangeAdminPassword,
    Detail,
    ReactiveDialog,
    NoPermission,
  },
  validations: {
    ChangePasswordform: {
      firstname: { required },
      email: { email },
      phone: {
        required,
        validNumber,
        maxLength: maxLength(15),
        minLength: minLength(7),
      },
    },
  },
  validationMessages: {
    form: {
      firstname: { required: "First name is required" },
      email: {
        email: "Email must be valid",
      },
      phone: {
        maxLength: "Max 14 digits",
        minLength: "Min 7 digits",
        validNumber: "Phone number must be a valid number",
      },
    },
  },
  data() {
    return {
      namespace: "Applications",
      page: "Users",
      showChangePassword: false,
      showChangeAdminPassword: false,
      showDetail: false,
      showEdit: false,
      showDelete: false,
      showReactive: false,
      selectedItem: {},

      tableOptions: {},

      filter: {
        SearchTerm: "",
        isDeleted: false,
        isActive: true,
      },

      clients: [],
      headers: defaultHeaders.map((item) => {
        let savedHeaders = getStorage(SETTING_LIST_KEY) || [];
        let nowHeader = savedHeaders.filter(
          (saved) => saved.value === item.value
        );

        if (nowHeader) {
          nowHeader = nowHeader[0];
        }
        return {
          ...item,
          ...nowHeader,
        };
      }),
    };
  },

  async created() {
    await this.refresh();
  },

  methods: {
    ...mapActions("user", ["applyTableFilter", "clearTableFilter"]),
    row_classes(item) {
      if (item.isDeleted) {
        return "user-deleted";
      }
    },

    onReactive(item) {
      this.selectedItem = item;
      this.showReactive = true;
    },
    onDelete(item) {
      this.selectedItem = item;
      this.showDelete = true;
    },
    onEdit(item) {
      this.selectedItem = item;
      this.showEdit = true;
    },
    onDetail(item) {
      this.selectedItem = item;
      this.showDetail = true;
    },
    onChangePassword(item) {
      this.selectedItem = item;
      this.showChangePassword = true;
    },
    onChangeAdminPassword(item) {
      this.selectedItem = item;
      this.showChangeAdminPassword = true;
    },
    clearChangePassword() {
      this.selectedItem = {};
      this.showChangePassword = false;
    },
    clearChangeAdminPassword() {
      this.selectedItem = {};
      this.showChangeAdminPassword = false;
    },
    clearDetail() {
      this.selectedItem = {};
      this.showDetail = false;
    },
    clearEdit() {
      this.selectedItem = {};
      this.showEdit = false;
    },
    clearDelete() {
      this.selectedItem = {};
      this.showDelete = false;
    },
    clearReactive() {
      this.selectedItem = {};
      this.showReactive = false;
    },

    refresh: _.debounce(async function () {
      this.applyTableFilter(this.computedFilter);
    }, 500),
  },

  computed: {
    ...mapGetters("account", ["hasAccess"]),
    ...mapState({
      account: (state) => state.account,
      alert: (state) => state.alert,
      loading: (state) => state.user.loadingTable,
      totalItems: (state) => state.user.metaData.totalEntries,
      dataItems: (state) => state.user.data,
    }),

    isLoading() {
      return this.loading && this.dataItems.length == 0;
    },

    computedFilter() {
      const { isDeleted, isActive, SearchTerm } = this.filter;
      let { sortBy, sortDesc, page, itemsPerPage } = this.tableOptions;
      let params = {
        PageNumber: page ? page : 1,
        PageSize: itemsPerPage > 0 ? itemsPerPage : 10,
      };

      params.OrderBy =
        sortBy && sortBy.length > 0 && sortBy[0] ? sortBy[0] : null;
      if (params.OrderBy) {
        params.Ascending =
          sortDesc && sortDesc.length > 0 && sortDesc[0] ? false : true;
      }
      if (isDeleted) {
        params.isDeleted = isDeleted;
      }
      if (isActive) {
        params.isActive = isActive;
      }
      if (SearchTerm) {
        params.SearchTerm = SearchTerm;
      }
      return params;
    },

    activeHeaders() {
      return this.headers.filter((header) => header.active);
    },
  },

  watch: {
    headers: {
      handler() {
        setStorage(SETTING_LIST_KEY, this.headers);
      },
      deep: true,
    },

    tableOptions: {
      async handler(n, o) {
        if (JSON.stringify(n) !== JSON.stringify(o)) {
          await this.refresh();
        }
      },
      deep: true,
    },

    filter: {
      async handler() {
        await this.refresh();
      },
      deep: true,
    },
  },

  async mounted() {
    await this.refresh();
  },

  beforeDestroy() {
    this.form = null;
    delete this.form;
    this.clearTableFilter();
  },
};
</script>